/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-06-15 17:38:33
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-09-09 15:48:34
 * @FilePath: \baishu_react_ui\src\Login\BsyRadioGroup\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import { BsyUtils } from "../../utils/Utils";
import BsyThumbList from "../BsyThumbList";
import { BsyWidget } from "../BsyWidget";
import "./index.css";
import { BsyFormula } from "../../global/Formula";

class BsySignature extends BsyWidget {
  static defaultProps = {
    baseCls: "bsy-signature bsy-upload ",

    width: 350,
    height: 30,
    info_height: null,
    allowBlank: !0,
    mode: "edit",
    thumbWidth: 65,
    thumbHeight: 65,
    noRepeat: !1,
    //超时时间 10分钟
    timeout: 60 * 10,
    signatureprPadUrl: window.location.protocol + "//" + window.location.host,
    onStopEdit: null,

    onValidateSuccess: null,
  };

  constructor(props) {
    super({
      ...props,
      title: React.language("phone.scan.signature"),
      waterMark: React.language("content.empty"),
    });

    this.value = props.value ? [...props.value] : null;
    this.element = React.createRef();
    // this.$uploadInput = React.createRef();
    // this.g_files = []//记录所有已经上传的文件信息
    // this.previewlist = [];
    // this.tokenKey = this.options.uploadToMedia ? "imageUploadToken" : "fileUploadToken";
    // this.tokenExpireKey = this.tokenKey + "Expires";
    // this.getUploadURL();
    // this.filterFiles();
  }

  componentDidMount() {
    super.componentDidMount();

    // BsyWebSocket()
  }

  _trimFileName = (a) => {
    if (BsyUtils.isEmpty(a)) return "";
    var b = 20,
      c = a ? a.split(".").pop() : "";
    if (a.length - c.length - 1 > b) {
      a = a.slice(0, b - 1);
      a = a + "..." + c;
    }

    //  a.length - c.length - 1 > b && (a = a.slice(0, b - 1),
    //     a = a + "..." + c)
    return a;
  };

  isUploaded = () => {
    return !BsyUtils.isObjectEmpty(this.value);
  };
  checkValidate = () => {
    var a = this.options,
      b = !0;
    this.setInvalidateTypeText("");
    a.allowBlank || (b = this.isUploaded());
    if (!b) {
      this.setInvalidateTypeText(React.language("item.required"));
    }
    b
      ? BsyUtils.applyFunc(this, a.onValidateSuccess, [], !1)
      : BsyUtils.applyFunc(this, a.onValidateFail, [], !1);
    BsyUtils.applyFunc(this, a.onAfterValidate, [], !1);
    return b;
  };

  getValue = () => {
    if (BsyUtils.isObjectEmpty(this.value)) {
      return [];
    }
    return [...this.value];
  };

  setValue = (e) => {
    if (!BsyUtils.isArray(e)) {
      this.value = [];
    } else {
      this.value = e;
    }

    this.setState({});
  };

  _createMultiplexSignaturePreview = (file, s) => {
    var _this = this;
    var _options = this.options;
    if (file) {
      var url = BsyUtils.getfiledownloadURL(file[0],{});
      _this.MultiplexSignaturepreview = window
        .$("<div />")
        .addClass("upload-info")
        .appendTo(s);
      window
        .$(
          '<div class="upload-preview" style="width: 330px;height: 98px  "><img src="' +
            url +
            '" style="width: 100%;height: 100%" /></div>'
        )
        .on("click", function () {
          new window.FX.FilePreview({
            formId: _options.formId,
            appId: _options.appId,
            dataId: _options.dataId,
            widgetType: "image",
            fieldName: _options.widgetName || _options.name,
            files: file,
            current: 0,
          });
        })
        .appendTo(_this.MultiplexSignaturepreview);
    }
  };

  createQr = (e) => {
    var _this = this;
    var _options = this.options;
    //多次点击的时候，需要清理上次的id
    _this.lastID = _this.signaturepreUUID;
    _this.signaturepreUUID = BsyFormula.MD5(window.FX.Utils.UUID());
    var url =
      _options.signatureprPadUrl +
      window.rootDirectroy +
      "/dashboard/signatureprPad/" +
      _this.signaturepreUUID;
    console.log("手写签名地址：" + url);

    if (!window.FX.STATIC.hasOwnProperty("RTOKEN")) {
      if (_this.ajaxing) return;
      _this.ajaxing = true;
      window.FX.Utils.ajax(
        {
          url: "/corp/retain_signature",
        },
        function (d) {
          var offOn = d.signature;
          if (offOn.length > 0) {
            var s = window.$("<div class='multiplex' />");
            window
              .$("<div class='title' />")
              .text(React.language("widget.signature.useSaved.tip"))
              .appendTo(s);
            _this._createMultiplexSignaturePreview(offOn, s);
            var mBtn = window.$("<div class='btn' />").appendTo(s);
            window
              .$("<div class='use' />")
              .on("click", function () {
                _this.setValue(offOn);
                // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                if (_this.bubble) {
                  _this.bubble.element.remove();
                }
                BsyUtils.applyFunc(_this, _options.onStopEdit, [offOn], !1);
              })
              .text(React.language("use"))
              .appendTo(mBtn);
            window
              .$("<div class='again' />")
              .on("click", function () {
                // $('.bby-msg-bubble').remove();
                if (_this.bubble) {
                  _this.bubble.element.remove();
                }
                window.FX.Utils.ajax(
                  {
                    url: "/corp/delete_signature",
                  },
                  function (d) {}
                );
                window.FX.WebSocket.on(_this.signaturepreUUID, _this.lastID, {
                  expTime: _options.timeout,
                  widgetName: _options.widgetName,
                  widgetType: "signature",
                  onCreateQR: function () {
                    // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                    if (_this.bubble) {
                      _this.bubble.element.remove();
                    }
                    if (_this.qrbubble) {
                      _this.qrbubble.element.remove();
                    }
                    _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
                      window.$(_this.element.current),
                      url,
                      React.language("scan.qr.signature")
                    );
                  },
                  onConnect: function () {
                    if (_this.qrbubble) {
                      _this.qrbubble.element.remove();
                    }
                  },
                  onStopEdit: function (i) {
                    //手动写图完成触发事件
                    if (i) {
                      if (i[0].retain) {
                        window.FX.Utils.ajax(
                          {
                            url: "/corp/save_signature",
                            data: i[0],
                          },
                          function (d) {}
                        );
                      }
                    }
                    _this.setValue(i);
                    // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                    if (_this.bubble) {
                      _this.bubble.element.remove();
                    }

                    window.FX.WebSocket._send({
                      type: "del",
                      signatureKey: _this.signaturepreUUID,
                    });
                    BsyUtils.applyFunc(
                      _this,
                      _options.onStopEdit,
                      [i, null, _this],
                      !1
                    );
                  },
                });
                if (window.FX.WebSocket.socket) {
                  // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                  if (_this.bubble) {
                    _this.bubble.element.remove();
                  }
                  if (_this.qrbubble) {
                    _this.qrbubble.element.remove();
                  }

                  _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
                    window.$(_this.element.current),
                    url,
                    React.language("scan.qr.signature")
                  );
                }
              })
              .text(React.language("widget.signature.rewrite"))
              .appendTo(mBtn);
            _this.bubble = window.FX.Msg.bubble({
              anchor: window.$(_this.element.current),
              text4Ok: null,
              minWidth: 350,
              dockPosition: "center",
              text4Cancel: null,
              contentHTML: s,
              hAdjust: 166,
              edge: 200,
            });
          } else {
            window.FX.WebSocket.on(_this.signaturepreUUID, _this.lastID, {
              expTime: _options.timeout,
              widgetName: _options.widgetName,
              widgetType: "signature",
              onCreateQR: function () {
                // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                if (_this.bubble) {
                  _this.bubble.element.remove();
                }
                if (_this.qrbubble) {
                  _this.qrbubble.element.remove();
                }
                _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
                  window.$(_this.element.current),
                  url,
                  React.language("scan.qr.signature")
                );
              },
              onConnect: function () {
                if (_this.qrbubble) {
                  _this.qrbubble.element.remove();
                }
              },
              onStopEdit: function (i) {
                //手动写图完成触发事件
                if (i) {
                  if (i[0].retain) {
                    window.FX.Utils.ajax(
                      {
                        url: "/corp/save_signature",
                        data: i[0],
                      },
                      function (d) {}
                    );
                  }
                }
                _this.setValue(i);
                // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
                if (_this.bubble) {
                  _this.bubble.element.remove();
                }
                window.FX.WebSocket._send({
                  type: "del",
                  signatureKey: _this.signaturepreUUID,
                });
                BsyUtils.applyFunc(
                  _this,
                  _options.onStopEdit,
                  [i, null, _this],
                  !1
                );
              },
            });
            if (window.FX.WebSocket.socket) {
              // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
              if (_this.bubble) {
                _this.bubble.element.remove();
              }
              if (_this.qrbubble) {
                _this.qrbubble.element.remove();
              }
              _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
                window.$(_this.element.current),
                url,
                React.language("scan.qr.signature")
              );
            }
          }
        },
        null,
        function () {
          _this.ajaxing = false;
        }
      );
    } else {
      window.FX.WebSocket.on(_this.signaturepreUUID, _this.lastID, {
        expTime: _options.timeout,
        widgetName: _options.widgetName,
        widgetType: "signature",
        onCreateQR: function () {
          // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
          if (_this.bubble) {
            _this.bubble.element.remove();
          }
          if (_this.qrbubble) {
            _this.qrbubble.element.remove();
          }
          _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
            window.$(_this.element.current),
            url,
            React.language("scan.qr.signature")
          );
        },
        onConnect: function () {
          if (_this.qrbubble) {
            _this.qrbubble.element.remove();
          }
        },
        onStopEdit: function (i) {
          //手动写图完成触发事件
          if (i) {
            _this.setValue(i);
            if (i[0].retain) {
              window.FX.Utils.ajax(
                {
                  url: "/corp/save_signature",
                  data: i[0],
                },
                function (d) {}
              );
            }
          }

          _this.setValue(i);
          // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
          if (_this.bubble) {
            _this.bubble.element.remove();
          }
          window.FX.WebSocket._send({
            type: "del",
            signatureKey: _this.signaturepreUUID,
          });
          BsyUtils.applyFunc(_this, _options.onStopEdit, [i, null, _this], !1);
        },
      });
      if (window.FX.WebSocket.socket) {
        // $('.bby-msg-bubble').length > 0 && $('.bby-msg-bubble').remove();
        if (_this.bubble) {
          _this.bubble.element.remove();
        }
        if (_this.qrbubble) {
          _this.qrbubble.element.remove();
        }
        _this.qrbubble = window.FX.Utils.createQrcodeDropDown(
          window.$(_this.element.current),
          url,
          React.language("scan.qr.signature")
        );
      }
    }
  };

  deleteFile = () => {
    this.value = [];
    this.setState({}, () => {
      BsyUtils.applyFunc(this, this.options.onStopEdit, [[], null, this], !1);
    });
  };

  renderBody = () => {
    const { formId, appId, dataId, widgetName } = this.options;
    if (!this.g_files) {
      this.g_files = [];
    }
    if (!this.previewlist) {
      this.previewlist = [];
    }
    if (BsyUtils.isObjectEmpty(this.value)) {
      if (this.isEnabled()) {
        return (
          <div className="signature-btn" onClick={this.createQr}>
            <i className="icon-widget-signature"></i>
            <span>{React.language("phone.scan.signature")}</span>
          </div>
        );
      }
    } else {
      let file = this.value[0];
      return (
        <div
          className={
            "upload-preview-list" + (this.value.length === 0 ? " empty" : "")
          }
        >
          <div className="upload-info">
            <div
              className="upload-preview"
              onClick={(e) => {
                new window.FX.FilePreview({
                  formId: formId,
                  appId: appId,
                  dataId: dataId,
                  fieldName: widgetName,
                  files: this.value,
                  current: 0,
                });
              }}
            >
              <img
                src={BsyUtils.getfiledownloadURL(file, {
                  mode: 2,
                  width: this.options.thumbWidth,
                  height: this.options.thumbHeight,
                })}
                alt=""
              />
            </div>
            {this.isEnabled() ? (
              <div
                className="signature-delete-btn"
                onClick={(e) => {
                  this.deleteFile();
                }}
              >
                <i className="icon-bby-trasho"></i>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      );
    }
  };

  render() {
    const { cssName, css } = this.options;
    if (!this.isEnabled() && BsyUtils.isObjectEmpty(this.value)) {
      return this.renderDisablePane("");
    }

    let style = { ...css };
    if (BsyUtils.isObjectEmpty(this.value)) {
      style.height = this.options.height;
    } else {
      style.height = "auto";
    }

    return (
      <div className={cssName} style={style} ref={this.element}>
        {this.renderBody()}
      </div>
    );
  }
}

export default BsySignature;
